<template>
    <div>
        <b-row>
            <b-col>
                <h1>{{ $t("recently_added") }}</h1>
            </b-col>
        </b-row>

        <Flicking
            v-if="files.length"
            class="recently-added-slider"
            :options="{ align: 'prev', bound: true, circular: false }"
        >
            <div v-for="file in files" :key="file.id">
                <div class="card" @click="exploreItem(file)">
                    <div class="card-body">
                        <div class="file">
                            <img
                                v-if="isImage(file.file_type)"
                                class="file-preview file-image"
                                width="80"
                                :src="file.square"
                                :data-source="file.url"
                            />
                            <div
                                v-else
                                class="file-preview file-icon"
                                :class="`${getFileTypeClass(file.file_type)}`"
                            ></div>
                        </div>
                        <component :is="file.resource_type" :file="file"></component>
                    </div>
                    <div class="card-footer">
                        <small class="text-muted">{{ $t("created_ago", {timeago: moment(file.created_at).fromNow()}) }}</small>
                    </div>
                </div>
            </div>
        </Flicking>
    </div>
</template>

<script>
import { Flicking } from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";
import { getFileTypeClass } from "../../plugins/utilities";
import axios from "axios";
import BaseProduct from "./RecentlyAdded/BaseProduct";
import Collection from "./RecentlyAdded/Collection";
import ProductVariant from "./RecentlyAdded/ProductVariant";
import moment from "moment";

export default {
  name: "FilesRecentlyAdded",
  components: {
    Flicking: Flicking,
    BaseProduct,
    Collection,
    ProductVariant
  },
  data() {
    return {
      files: []
    };
  },
  methods: {
    moment,
    getFileTypeClass,
    getLatestFiles() {
      axios.get("/api/smart-vault/latest-files").then(r => {
        this.files = r.data.data;
      });
    },
    openFile(file) {
      window.open(file.url);
    },
    isImage(file_type) {
      return !!file_type.startsWith("image/");
    },
    exploreItem(item) {
      if (item.resource_type === "BaseProduct") {
        window.location = `/smart-vault/${item.resource.id}`;
      } else if (item.resource_type === "Collection") {
        this.$store.commit("smartVaultSearch/setClientAndCollection", {
          client: item.resource.client.id,
          collection: item.resource.id
        });
      } else if (item.resource_type === "ProductVariant") {
        window.location = `/smart-vault/${item.resource.base_product.id}/${
          item.resource.id
        }`;
      } else {
        window.location = `/smart-vault/${item.resource.id}`;
      }
    }
  },
  mounted() {
    this.getLatestFiles();
  }
};
</script>
